// extracted by mini-css-extract-plugin
export default {"root":"IconModify_root__kIZOz"};